import { isModuleImportError as sharedIsModuleImportError } from '@stamhoofd/frontend-notifications/isModuleImportError';

/** @deprecated Import isModuleImportError from @stamhoofd/frontend-notifications/isModuleImportError instead. */
export const isModuleImportError = sharedIsModuleImportError;
